/**
 * One factory for every admin query key, so invalidation after a mutation is
 * exact rather than a blanket refetch. A grid that refetches everything on every
 * inline edit is how an operations tool starts feeling slow.
 */
export const queryKeys = {
  dashboard: () => ['dashboard'],
  session: () => ['session'],

  products: {
    all: ['products'],
    list: (filters) => ['products', 'list', filters ?? {}],
    detail: (id) => ['products', 'detail', id],
    variants: (id) => ['products', 'variants', id],
  },
  collections: { all: ['collections'], list: () => ['collections', 'list'] },
  categories: { all: ['categories'], list: (filters) => ['categories', 'list', filters ?? {}] },
  brands: { all: ['brands'], list: (filters) => ['brands', 'list', filters ?? {}] },
  attributes: { all: ['attributes'], list: (filters) => ['attributes', 'list', filters ?? {}], detail: (id) => ['attributes', id] },
  specTemplates: { all: ['spec-templates'], list: () => ['spec-templates', 'list'] },
  tags: { all: ['tags'], list: () => ['tags', 'list'] },

  media: { all: ['media'], list: (filters) => ['media', 'list', filters ?? {}], stats: () => ['media', 'stats'], folders: () => ['media', 'folders'] },

  orders: { all: ['orders'], list: (filters) => ['orders', 'list', filters ?? {}], detail: (id) => ['orders', 'detail', id] },
  customers: { all: ['customers'], list: (filters) => ['customers', 'list', filters ?? {}], detail: (id) => ['customers', 'detail', id] },
  coupons: { all: ['coupons'], list: (filters) => ['coupons', 'list', filters ?? {}], detail: (id) => ['coupons', 'detail', id], redemptions: (id) => ['coupons', id, 'redemptions'] },
  reviews: { all: ['reviews'], list: (filters) => ['reviews', 'list', filters ?? {}], detail: (id) => ['reviews', 'detail', id] },

  blog: { all: ['blog'], list: (filters) => ['blog', 'list', filters ?? {}], detail: (id) => ['blog', 'detail', id], categories: () => ['blog', 'categories'] },
  pages: { all: ['pages'], list: (filters) => ['pages', 'list', filters ?? {}], detail: (id) => ['pages', 'detail', id] },
  enquiries: { all: ['enquiries'], list: (filters) => ['enquiries', 'list', filters ?? {}] },

  settings: { all: ['settings'], list: () => ['settings', 'list'] },
  staff: { all: ['staff'], list: (filters) => ['staff', 'list', filters ?? {}], detail: (id) => ['staff', 'detail', id], permissions: () => ['staff', 'permissions'] },
  activity: { all: ['activity'], list: (filters) => ['activity', 'list', filters ?? {}], facets: () => ['activity', 'facets'] },
};

export default queryKeys;
